import React, { useState, useEffect } from 'react';
import '../Payment/summary.css';
import axios from 'axios';
import Select from 'react-select';
import { useUser } from '../context/UserContext';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

const Summary = () => {
  const [summaries, setSummaries] = useState([]);
  const [academies, setAcademies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { userData } = useUser();
  const token = localStorage.getItem('auth-token');
  const [paymentMethodFilter, setPaymentMethodFilter] = useState('');
  const [paymentTypeFilter, setPaymentTypeFilter] = useState('');
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const apiUrl = process.env.REACT_APP_API_ACADEMY_PAYMENT_SUMMARY;

  const today = new Date();
  const tenDaysAgo = new Date(today);
  tenDaysAgo.setDate(today.getDate() - 10);

  const [fromDate, setFromDate] = useState(tenDaysAgo.toISOString().split('T')[0]);
  const [toDate, setToDate] = useState(today.toISOString().split('T')[0]);

  const fetchData = async () => {
    setLoading(true);
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };

    const requestBody = {
      fromDate,
      toDate,
      paymentMethods: paymentMethodFilter || null,
      paymentTypes: paymentTypeFilter || null
    };

    try {
      const response = await axios.post(apiUrl, requestBody, { headers });

      if (response.data.success) {
        let filteredPayments = response.data.data.payments;
        if (userData?.userType === 'ACADEMY') {
          filteredPayments = filteredPayments.filter(payment =>
            userData.academyIds.includes(payment.academy.id)
          );
        }

        const paymentData = filteredPayments.map(payment => ({
          id: payment.academy.id,
          academyName: payment.academy.name,
          amountReceived: payment.totalTransferableAmount,
          amountPaid: payment.totalAmountPaid,
          amountDues: payment.sumOfPaymentDueAcademyWise,
          paymentMethod: payment.paymentMethod,
          paymentType: payment.paymentType,
          date: payment.createdAt,
        }));

        setSummaries(paymentData);

        const uniqueAcademies = Array.from(
          new Set(filteredPayments.map(payment => payment.academy.name))
        );
        setAcademies(uniqueAcademies);

        setPaymentMethods(response.data.data.paymentMethods || []);
        setPaymentTypes(response.data.data.paymentTypes || []);
      }
    } catch (err) {
      setError("Failed to fetch summary data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, userData, paymentMethodFilter, paymentTypeFilter]);



  const academyOptions = academies.map(academy => ({ value: academy, label: academy }));

  const paymentMethodOptions = paymentMethods.map(method => ({
    value: method,
    label: method
  }));

  const paymentTypeOptions = paymentTypes.map(type => ({
    value: type,
    label: type
  }));

  const headers = [
    { key: 'academyName', label: 'Academy Name' },
    { key: 'amountReceived', label: 'Amount Received' },
    { key: 'amountPaid', label: 'Amount Paid' },
    { key: 'amountDues', label: 'Amount Dues' },
  ];
  const [searchTerm, setSearchTerm] = useState('');
  const [academyFilter, setAcademyFilter] = useState('');


  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleAcademyChange = selectedOption => {
    setAcademyFilter(selectedOption ? selectedOption.value : '');
  };

  const handlePaymentMethodChange = selectedOption => {
    setPaymentMethodFilter(selectedOption ? selectedOption.value : '');
  };

  const handlePaymentTypeChange = selectedOption => {
    setPaymentTypeFilter(selectedOption ? selectedOption.value : '');
  };


  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const filteredSummaries = summaries.filter((summary) => {
    const matchesSearchTerm =
      summary.academyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      summary.amountReceived.toString().includes(searchTerm) ||
      summary.amountPaid.toString().includes(searchTerm) ||
      summary.amountDues.toString().includes(searchTerm);

    const matchesAcademy = !academyFilter || summary.academyName === academyFilter;


    return matchesSearchTerm && matchesAcademy;
  });
  const handleSort = (columnKey) => {
    setSortConfig((prev) => ({
      key: columnKey,
      direction: prev.key === columnKey && prev.direction === "ascending" ? "descending" : "ascending",
    }));
  };


  const sortData = (data) => {
    const { key, direction } = sortConfig;
    return [...data].sort((a, b) => {
      if (!key) return 0;

      if (typeof a[key] === "string") {
        return direction === "ascending"
          ? a[key].localeCompare(b[key])
          : b[key].localeCompare(a[key]);
      }

      return direction === "ascending" ? a[key] - b[key] : b[key] - a[key];
    });
  };

  const sortedData = sortData(filteredSummaries);
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };
  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };


  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };
  const totalEntries = filteredSummaries.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;
  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">

        <div className={`floating-select ${academyFilter ? 'has-value' : ''}`}>
          <Select
            options={academyOptions}
            value={academyOptions.find(opt => opt.value === academyFilter)}
            onChange={handleAcademyChange}
            className={`sales-filter-court-booking ${academyFilter ? "has-value" : ""}`}
            isClearable
            placeholder="Academy"
            classNamePrefix="react-select"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {academyFilter && <label>Academy</label>}
        </div>

        <div className={`floating-select ${paymentMethodFilter ? 'has-value' : ''}`}>
          <Select
            options={paymentMethodOptions}
            value={paymentMethodOptions.find(opt => opt.value === paymentMethodFilter)}
            onChange={handlePaymentMethodChange}
            className={`sales-filter-court-booking ${paymentMethodFilter ? "has-value" : ""}`}
            placeholder="Method"
            isClearable
            classNamePrefix="react-select"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {paymentMethodFilter && <label>Payment Method</label>}
        </div>
        <div className={`floating-select ${paymentTypeFilter ? 'has-value' : ''}`}>
          <Select
            options={paymentTypeOptions}
            value={paymentTypeOptions.find(opt => opt.value === paymentTypeFilter)}
            onChange={handlePaymentTypeChange}
            className={`sales-filter-court-booking ${paymentTypeFilter ? "has-value" : ""}`}
            placeholder="Type"
            isClearable
            classNamePrefix="react-select"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {paymentTypeFilter && <label>Payment Type</label>}
        </div>


        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-court-booking ${fromDate ? "has-value" : ""}`}
            value={fromDate}
            onChange={handleFromDateChange}
            onFocus={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {fromDate && <label htmlFor="fromDate">Start Date</label>}
        </div>


        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${toDate ? "has-value" : ""}`}
            value={toDate}
            onChange={handleToDateChange}
            onFocus={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {toDate && <label htmlFor="toDate">To Date</label>}
        </div>

      </div>

      <div className="filter-row">
        <div className="search-bar">
          <div className="input-container">
            <input
              type="text"
              id="searchInput"
              placeholder=""
              className={`search-input ${searchTerm ? "has-value" : ""}`}
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <label htmlFor="searchInput" className="floating-label">
              🔍 Search
            </label>
          </div>
        </div>
      </div>
      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredSummaries.length === 0 && (
        <div className="error-message">No data available</div>
      )}
      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map(summary => (
              <tr key={summary.id}>
                <td>{summary.academyName}</td>
                <td>{summary.amountReceived}</td>
                <td>{summary.amountPaid}</td>
                <td>{summary.amountDues}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* )} */}
      {/* Pagination */}
      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Summary;
